import { toast as sonner } from 'sonner';

// Nestix pages call toast({ title, description, variant }); route them to the app's mounted sonner Toaster.
function toast({ title, description, variant } = {}) {
  const show = variant === 'destructive' ? sonner.error : sonner.success;
  const id = show(title || description || '', title && description ? { description } : undefined);
  return { id, dismiss: () => sonner.dismiss(id), update: () => {} };
}

function useToast() {
  return { toast, toasts: [], dismiss: (id) => sonner.dismiss(id) };
}

export { useToast, toast };
